/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The OnboardingModelState model module.
 * @module model/OnboardingModelState
 * @version V1
 */
class OnboardingModelState {
    /**
     * Constructs a new <code>OnboardingModelState</code>.
     * @alias module:model/OnboardingModelState
     */
    constructor() { 
        
        OnboardingModelState.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>OnboardingModelState</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OnboardingModelState} obj Optional instance to populate.
     * @return {module:model/OnboardingModelState} The populated <code>OnboardingModelState</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OnboardingModelState();

            if (data.hasOwnProperty('hasCreatedProofModelShown')) {
                obj['hasCreatedProofModelShown'] = ApiClient.convertToType(data['hasCreatedProofModelShown'], 'Boolean');
            }
            if (data.hasOwnProperty('hasReviewLinkRegisteredModelShown')) {
                obj['hasReviewLinkRegisteredModelShown'] = ApiClient.convertToType(data['hasReviewLinkRegisteredModelShown'], 'Boolean');
            }
            if (data.hasOwnProperty('hasEmailTemplateCreatedModelShown')) {
                obj['hasEmailTemplateCreatedModelShown'] = ApiClient.convertToType(data['hasEmailTemplateCreatedModelShown'], 'Boolean');
            }
            if (data.hasOwnProperty('hasUsedWorkflowModelShown')) {
                obj['hasUsedWorkflowModelShown'] = ApiClient.convertToType(data['hasUsedWorkflowModelShown'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>OnboardingModelState</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>OnboardingModelState</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Boolean} hasCreatedProofModelShown
 */
OnboardingModelState.prototype['hasCreatedProofModelShown'] = undefined;

/**
 * @member {Boolean} hasReviewLinkRegisteredModelShown
 */
OnboardingModelState.prototype['hasReviewLinkRegisteredModelShown'] = undefined;

/**
 * @member {Boolean} hasEmailTemplateCreatedModelShown
 */
OnboardingModelState.prototype['hasEmailTemplateCreatedModelShown'] = undefined;

/**
 * @member {Boolean} hasUsedWorkflowModelShown
 */
OnboardingModelState.prototype['hasUsedWorkflowModelShown'] = undefined;






export default OnboardingModelState;

